@if (station(); as stationData) {
  <div class="flex flex-col h-full overflow-hidden bg-gray-100">
    <!-- Header -->
    <div class="p-4 bg-white">
      @if (showBackToResults()) {
        <button
          class="flex items-center gap-2 font-bold text-primary-40 hover:text-primary-30 cursor-pointer bg-transparent border-none p-0 mb-6"
          (click)="onBackClick()"
        >
          <lds-icon [name]="Icon.ARROW_LEFT" />
          <span class="text-body-2-desktop">{{ 'backToResults' | translate }}</span>
        </button>
      }

      <!-- Station name row with status badge -->
      <div class="flex items-center gap-2">
        @if (isCoucheTardBrand()) {
          <img class="w-8 h-8 shrink-0" src="/assets/couche-tard-logo.svg" alt="" />
        } @else {
          <lds-logo [variant]="LogoVariant.NO_TEXT" />
        }
        <p class="text-xl font-bold m-0">{{ displayName() }}</p>
        <lds-badge class="font-medium text-xs" [color]="statusBadgeColor()" [type]="BadgeType.FLAT" [size]="Size.SM">
          {{ statusLabel() }}
        </lds-badge>
      </div>
    </div>
    <div class="relative flex-1 overflow-hidden">
      <div class="h-full overflow-y-auto p-4">
        <!-- Address Section -->
        <div class="mb-4">
          <div class="flex items-center gap-2">
            <div class="flex items-center gap-2">
              <lds-icon [name]="Icon.MARKER_PIN_01" class="text-gray-40 flex-shrink-0" />
              <p class="font-medium text-body-2-desktop m-0">{{ fullAddress() }}</p>
            </div>
            <button
              class="flex-shrink-0 cursor-pointer bg-transparent border-none p-1 text-gray-40 hover:text-gray-10"
              [attr.aria-label]="'copyAddress' | translate"
              (click)="onCopyAddress()"
            >
              <lds-icon [name]="Icon.COPY_01" />
            </button>
          </div>
        </div>

        <!-- Phone Section -->
        @if (stationData.phoneNumber) {
          <div class="mb-4 pb-4 border-b border-gray-90">
            <a [href]="'tel:' + stationData.phoneNumber" class="flex items-center gap-2 no-underline">
              <lds-icon [name]="Icon.PHONE" class="text-primary-40" />
              <span class="font-medium text-sm text-[#1C6BD9]">{{ formattedPhoneNumber() }}</span>
            </a>
          </div>
        }

        <!-- Quick Indicators -->
        @if (is24Hours() || hasFuels() || hasEvCharging()) {
          <div class="mb-4">
            <div class="flex items-center gap-4">
              @if (hasFuels()) {
                <div
                  class="flex bg-bg-tertiary p-2 rounded-lg items-center gap-2 text-gray-40"
                  ldsTooltip
                  [tooltipText]="'fuel' | translate"
                >
                  <lds-icon [name]="Icon.DISPENSER" [size]="Size.SM" class="text-lg" />
                </div>
              }
              @if (hasEvCharging()) {
                <div
                  class="flex bg-bg-tertiary p-2 rounded-lg items-center gap-2 text-gray-40"
                  ldsTooltip
                  [tooltipText]="'evCharging' | translate"
                >
                  <lds-icon [name]="Icon.ZAP" [size]="Size.SM" class="text-lg" />
                </div>
              }
              @if (is24Hours()) {
                <div class="flex items-center gap-2 text-gray-40">
                  <div class="bg-bg-tertiary p-2 rounded-lg">
                    <lds-icon [name]="Icon.CLOCK" [size]="Size.SM" class="text-lg" />
                  </div>
                  <span class="text-body-2-desktop font-medium">{{ 'available24Hours' | translate }}</span>
                </div>
              }
            </div>
          </div>
        }

        <!-- Opening Hours Section -->
        @if (stationData.openingHours && !is24Hours()) {
          <div class="mb-4">
            <app-opening-hours [openingHours]="stationData.openingHours" />
          </div>
        }

        <div class="mb-4 flex gap-2 [&>lds-button]:flex-1 [&>lds-button]:w-full">
          <lds-button [variant]="ButtonVariant.PRIMARY" [expand]="ButtonExpand.FULL" (click)="onDirectionsClick()">
            <div class="flex items-center justify-center gap-2">
              <lds-icon [name]="Icon.CORNER_UP_RIGHT" />
              <span>{{ 'directions' | translate }}</span>
            </div>
          </lds-button>
          <!-- View on map button - mobile only -->
          <lds-button
            class="md:hidden"
            [variant]="ButtonVariant.SECONDARY"
            [expand]="ButtonExpand.FULL"
            (click)="onViewMapClick()"
          >
            {{ 'viewOnMap' | translate }}
          </lds-button>
        </div>

        <!-- Tabs Section -->
        @if (visibleTabs().length > 0) {
          <div class="mt-4 w-full">
            <lds-tabs
              [tabs]="visibleTabs()"
              [selected]="clampedTabIndex()"
              (tabSelected)="onTabSelected($event)"
              [fullWidth]="true"
            />
            @if (activeTabContent() === 'services') {
              <app-station-tab-content
                [type]="stationFeatureCategory.SERVICES"
                [items]="regularServices()"
                [icon]="Icon.PUZZLE_PIECE_01"
              />
            }
            @if (activeTabContent() === 'fuel') {
              <app-station-tab-content
                [type]="stationFeatureCategory.FUELS"
                [items]="fuels()"
                [icon]="Icon.DISPENSER"
              />
            }
            @if (activeTabContent() === 'truckServices') {
              <app-station-tab-content
                [type]="stationFeatureCategory.TRUCK_SERVICES"
                [items]="truckServices()"
                [icon]="Icon.TRUCK_01"
              />
            }
          </div>
        }
      </div>
      <div
        class="md:hidden absolute bottom-0 left-0 right-0 h-12 pointer-events-none"
        style="background: linear-gradient(to top, white 0%, transparent 100%)"
      ></div>
    </div>

    <!-- Map Modal (Mobile Only) -->
    @if (isMapModalOpen()) {
      <app-map-modal [station]="stationData" (close)="onMapModalClose()" />
    }
  </div>
}
